import React from 'react';

import { Options } from './types';

interface TrackingContextType<T> {
	tracking: Options<T> & { data?: Record<string, unknown> | undefined }
}

export default React.createContext({} as TrackingContextType<any>);
